import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, AngularFireList  } from 'angularfire2/database';
import { Post } from '../../class/post';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

  posts: Post[];
  postsRef: AngularFireList<any>;

  constructor(private db: AngularFireDatabase) { 
    this.postsRef = this.db.list('posts');
  }

  ngOnInit() {
    this.postsRef.snapshotChanges()
    .subscribe(snapshots => {
      this.posts = snapshots.map(snapshot => {
        const values = snapshot.payload.val();
        return new Post({ key: snapshot.payload.key, ...values });
      });
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/form/list/list.component.ts